module.exports = __webpack_public_path__ + "static/media/Group 24444.34797da3.svg";